<template>
  <div>
    <v-navigation />

    <div v-if="hasSlot('nav')">
      <slot name="nav" />
    </div>
    <v-content>
      <v-container
        fluid
        class="layout-container"
      >
        <v-layout>
          <v-flex class="main-container">
            <slot />

            <div v-if="hasSlot('header')">
              <slot name="header" />
            </div>

            <div v-if="hasSlot('body')">
              <slot name="body" />
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
/* ============
 * Default Layout
 * ============
 *
 * Used for the home and account pages.
 *
 * Layouts are used to store a lot of shared code.
 * This way the app stays clean.
 */

import VNavigation from '@/components/Navigation.vue';
import SlotMixin from '@/mixins/slot';

// eslint-disable-next-line
import {
  VContainer,
  VLayout,
  VFlex,
} from 'vuetify/lib';

export default {
  name: 'DefaultLayout',

  components: {
    VNavigation,
    VContainer,
    VLayout,
    VFlex,
  },

  mixins: [
    SlotMixin,
  ],
};
</script>
